import { useBooleanState } from '@calendly/hooks'
import { I18n } from '@calendly/i18n'
import { MinimalButton } from '@calendly/ui/components/minimal-button'
import { useState, useRef, useCallback } from 'react'

import { MeetingsFilterMenu } from 'components/cui_filter_menu'

import { FilterButton } from './filter_button'
import { getMeetingsFilterMenuPortalRoot } from './filter_menu_portal_root'
import { SearchFilterModal } from './search_filter_modal'
import { searchResetParams, changedSearchFilters } from './utils'

export const SearchFilter = ({ filters, setFilters, searchQuery }) => {
  const [isModalOpen, openModal, closeModal] = useBooleanState(false)
  const [currentFilters, setCurrentFilters] = useState(filters)
  const changedFilters = changedSearchFilters(filters)
  const filterCount = changedFilters.length
  const filterButtonRef = useRef(null)

  const handleCloseModal = useCallback(() => {
    closeModal()
  }, [closeModal])

  const handleOpenChange = useCallback((nextIsOpen) => {
    if (nextIsOpen) {
      getMeetingsFilterMenuPortalRoot()
      openModal()
    } else {
      handleCloseModal()
    }
  }, [handleCloseModal, openModal])

  const onResetFilters = () => {
    setCurrentFilters(searchResetParams(searchQuery))
    setFilters(searchResetParams(searchQuery))
  }

  return (
    <>
      <MeetingsFilterMenu
        isOpen={isModalOpen}
        onOpenChange={handleOpenChange}
        onClose={handleCloseModal}
        contentMinWidth="comfortable"
        placement="bottom start"
      >
        <FilterButton
          ref={filterButtonRef}
          isModalOpen={isModalOpen}
          filterCount={filterCount}
        />
        {isModalOpen && (
          <SearchFilterModal
            onClose={handleCloseModal}
            filters={filters}
            setFilters={setFilters}
            searchQuery={searchQuery}
            resetParams={searchResetParams(searchQuery)}
            currentFilters={currentFilters}
            setCurrentFilters={setCurrentFilters}
          />
        )}
      </MeetingsFilterMenu>
      {filterCount > 0 && (
        <MinimalButton onClick={onResetFilters}>
          {I18n.t('publisher.scheduling.shared.empty_state.filter.button.clear')}
        </MinimalButton>
      )}
    </>
  )
}
